(function () {
	'use strict';
	$(document).ready(function () {

		$('.js-team-tile-open').on('click', function (e) {
			e.preventDefault();
			$(this).siblings('.team-member-popup').fadeIn({
				start: function () {
					$(this).css({
						display: 'flex',
					});
				},
			});
		});

		$('.js-team-tile-close').on('click', function () {
			$('.team-member-popup').fadeOut();
		});

		if (document.querySelector('.news .filters')) {
			const urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('c')) {
				$('html, body').animate({
					scrollTop: $('.news .filters').offset().top - 30,
				}, 1000);
			}
		}

		if (document.querySelector('.innovations-filters')) {
			const urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('t')) {
				$('html, body').animate({
					scrollTop: $('.innovations-filters').offset().top,
				}, 1000);
			}
		}

		$('.subpage .swiper-quotations').each(function () {
			const $this = $(this);

			const swiper = new Swiper($(this)[0], {
				loop: true,
				autoHeight: true,
				slidesPerView: 1,
				spaceBetween: 30,
				pagination: {
					el: Array.from($this[0].querySelectorAll('.swiper-pagination')),
				},
			});

			$this.on('click', function () {
				swiper.slideNext();
			});
		});

		document.querySelectorAll('.js-copy-link-btn').forEach(function (button) {
			button.addEventListener('click', function () {
				navigator.clipboard.writeText(window.location.href).then(function () {
					const copiedInfo = button.querySelector('.js-copy-link-info');
					copiedInfo.classList.add('active');

					setTimeout(function () {
						copiedInfo.classList.remove('active');
					}, 3000);
				});
			});
		});

		var lightbox = new SimpleLightbox('.gallery-list a', {});

		if ($('.gallery-more').length) {
			$('.gallery-more').on('click', function (e) {
				const gallery = $(this).parents('ul');
				gallery.find('li.hidden').slice(0, 6).removeClass('hidden');
				const remaining = gallery.find('li.hidden').length;
				if (remaining > 0) {
					$(this).find('span').text(remaining);
				} else {
					$(this).parent().remove();
				}
				e.preventDefault();
			});
		}

		$('.column-expand-btn').on('click', function () {
			$(this).siblings('.column-expand-content').slideToggle();

			let currentText = $(this).text();
			if (currentText === window.fh_config.translations['zobacz_wiecej']) {
				$(this).text(window.fh_config.translations['zwin']);
			} else {
				$(this).text(window.fh_config.translations['zobacz_wiecej']);
			}
		});

		//Innovations filters

		$('.innovations-filters-dropdown-toggle').on('click', function () {
			if (!$(this).hasClass('open')) {
				$('.innovations-filters-dropdown-toggle.open').removeClass('open').siblings(
					'.innovations-filters-dropdown-list').slideUp();
			}
			$(this).toggleClass('open').siblings('.innovations-filters-dropdown-list').slideToggle();
		});

		clickedOutside('.innovations-filters-dropdown', function () {
			$('.innovations-filters-dropdown-toggle').removeClass('open');
			$('.innovations-filters-dropdown-list').slideUp();
		}, ['.innovations-filters-dropdown-toggle']);

		$('.innovations-filters-dropdown-list input:checkbox').on('click', function () {
			const group = $(this).attr('name');
			const checkedCount = $('input[name="' + group + '"]:checked').length;

			const inputLabel = $(this).closest('.innovations-filters-dropdown').find(
				'.innovations-filters-dropdown-toggle').data('toggle-label');

			if (checkedCount > 0) {
				$(this).closest('.innovations-filters-dropdown').find(
					'.innovations-filters-dropdown-toggle span').text(inputLabel + ' (' + checkedCount + ')');
			} else {
				$(this).closest('.innovations-filters-dropdown').find(
					'.innovations-filters-dropdown-toggle span').text(inputLabel);
			}
		});

		$('.innovations-filters-reset').on('click', function () {
			$('.innovations-filters-dropdown-toggle').each(function () {
				const toggleLabel = $(this).data('toggle-label');
				$(this).find('span').text(toggleLabel);
			});
			$('.innovations-filters-dropdown-list input[type="checkbox"]').prop('checked', false);
			$('.innovations-tags a').each(function() {
				let tagDefaultHref = $(this).data('href');
				$(this).removeClass('active').attr('href', '?tagi-innowacji[]=' + tagDefaultHref);
			});
			const url = window.location.protocol + "//" + window.location.host + window.location.pathname;
			window.history.replaceState({}, document.title, url);
		});

		$('.innovations-tags-toggle').on('click', function (e) {
			e.preventDefault();
			$('.innovations-tags').toggleClass('open');

			let currentText = $('.innovations-tags-toggle-label').text();
			if (currentText === window.fh_config.translations['tagi_wiecej']) {
				$('.innovations-tags-toggle-label').text(window.fh_config.translations['tagi_mniej']);
			} else {
				$('.innovations-tags-toggle-label').text(window.fh_config.translations['tagi_wiecej']);
			}

			$('.innovations-tags-toggle-count').toggle();
		});

		//Innovations filters

		// handle tables in accordions
		$('.subpage .accordion .collapse').on('shown.bs.collapse', function () {
			updateTableSize();
			$(window).resize();
		});

		// accordion scroll animation
		$('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function () {
			const positionTop = $(this).parent().offset().top; // - $('header').height();
			$('html, body').animate({
				scrollTop: positionTop,
			}, 500);
		});

		$('.video .video-container').find('video, .js-video-play').on('click', function () {
			var video = $(this).parent().find('video')[0];
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
			$('.js-video-play').fadeToggle();
		});

		// responsive-image module zoomable feature
		document.querySelectorAll(
			'.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
			const popupContainer = document.createElement('div');
			popupContainer.classList.add('popup-image-container');
			const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(
				true);
			clonedImg.classList.add('popup-image');
			popupContainer.appendChild(clonedImg);

			const removePopupContainer = () => {
				$(popupContainer).fadeOut(() => {
					popupContainer.remove();
				});
			};
			popupContainer.addEventListener('click', removePopupContainer);

			const mediaQuery = window.matchMedia('(min-width: 768px)');
			mediaQuery.addEventListener('change', () => {
				if (!mediaQuery.matches) {
					removePopupContainer();
				}
			});
			containerElement.querySelector('img').addEventListener('click', () => {
				if (mediaQuery.matches) {
					document.body.appendChild(popupContainer);
					$(popupContainer).fadeIn();
				}
			});
		});

		//Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

	});
}(jQuery));
